import { chartAxes } from '../../constants/event';
import { sortingOptions, sortingOrder } from '../../constants/common';
import { getView, getViews } from '../../utils/event/common';

const columnChartSortingInitialState = {
  axis: chartAxes.Y,
  order: sortingOrder.DESCENDING,
  sortingOptions: sortingOptions.INDEPEND,
};

const executeInitialState = {
  events: null,
  revenue: null,
  payers: null,
  uniqueUsers: null,
  queryType: null,
  executeTime: 0,
  currencySymbol: '$',
  executing: false,
  executeId: '',
  options: {
    columnChartSorting: columnChartSortingInitialState,
    views: [],
    view: undefined,
    singleChartMode: true,
    showFormula: false,
    calcTotal: false,
    averageLine: false,
    medianLine: false,
    trendLine: false,
    showSortingOptions: false,
    enteredFormula: null,
    adaptive: false,
    isExpand: false,
  },
};

const execute = (state = executeInitialState, action) => {
  switch (action.type) {
    case 'EXECUTE_REVENUE_QUERIES_SUCCESS':
      return {
        ...state,
        options: {
          ...state.options,
          view: getView(state.options.view, action.events),
          views: getViews(action.events),
          ...action.options,
        },
        events: action.events,
        revenue: action.revenue,
        payers: action.payers,
        uniqueUsers: action.uniqueUsers,
        executeTime: new Date().valueOf(),
        currencySymbol: action.currencySymbol || '$',
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_REVENUE_QUERIES_FAILURE':
      return {
        ...state,
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_REVENUE_QUERIES':
      return {
        ...state,
        events: [],
        revenue: null,
        payers: null,
        uniqueUsers: null,
        executing: true,
      };

    case 'SET_REVENUE_EXECUTE_ID':
      return {
        ...state,
        executeId: action.executeId,
      };

    case 'CHANGE_REVENUE_VIEW':
      return {
        ...state,
        options: {
          ...state.options,
          view: action.view,
          showFormula: false,
        },
      };

    case 'ASSIGN_REVENUE_TYPE_QUERY':
      return {
        ...state,
        queryType: action.queryType,
      };

    case 'TOGGLE_REVENUE_CALC_TOTAL':
      return {
        ...state,
        options: {
          ...state.options,
          calcTotal: !state.options.calcTotal,
        },
      };

    case 'TOGGLE_REVENUE_TREND_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          trendLine: !state.options.trendLine,
        },
      };

    case 'TOGGLE_REVENUE_AVERAGE_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          averageLine: !state.options.averageLine,
        },
      };

    case 'TOGGLE_REVENUE_MEDIAN_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          medianLine: !state.options.medianLine,
        },
      };

    case 'TOGGLE_REVENUE_ADAPTIVE':
      return {
        ...state,
        options: {
          ...state.options,
          adaptive: !state.options.adaptive,
        },
      };

    case 'CHANGE_REVENUE_COLUMN_CHART_SORTING':
      return {
        ...state,
        options: {
          ...state.options,
          columnChartSorting: action.sorting,
        },
      };

    case 'REVENUE_SET_EXPAND':
      return {
        ...state,
        options: {
          ...state.options,
          isExpand: action.value,
        },
      };

    default:
      return state;
  }
};

export default execute;

export const getEvents = (state) => state.events;

export const getRevenue = (state) => state.revenue;

export const getPayers = (state) => state.payers;

export const getExecutedQueryType = (state) => state.queryType;

export const getOptions = (state) => state.options;

export const getUniqueUsers = (state) => state.uniqueUsers;

export const getExecuteTime = (state) => state.executeTime;

export const getRevenueCurrencySymbol = (state) => state.currencySymbol;

export const isExecuting = (state) => state.executing;

export const getExecuteId = (state) => state.executeId;
